import { render, staticRenderFns } from "./ChuyouTransfermap.vue?vue&type=template&id=65e46683&scoped=true&"
import script from "./ChuyouTransfermap.vue?vue&type=script&lang=js&"
export * from "./ChuyouTransfermap.vue?vue&type=script&lang=js&"
import style0 from "./ChuyouTransfermap.vue?vue&type=style&index=0&id=65e46683&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e46683",
  null
  
)

export default component.exports